import recipes from '../../data/recipes.json';
import rawResource from '../../data/rawResources.json';
import { getObject } from './objects';
const getAllRecipesList = () => {
    return recipes;
};
const getObjectRecipes = (objectName) => {
    if (!recipes[objectName]) {
        return [];
    }
    return recipes[objectName];
};
const getObjectDefaultRecipe = (objectName) => {
    if (!recipes[objectName]) {
        return;
    }
    return recipes[objectName][0];
};
const getRecipeDependenciesTree = (recipe, finalObjectQuantity) => {
    const result = {
        object: getObject(recipe.product),
        tool: recipe.tool,
        quantity: finalObjectQuantity,
        type: 'not_raw',
        resources: {}
    };
    for (const resource of Object.keys(recipe.resources)) {
        const quantity = recipe.resources[resource];
        if (rawResource[resource]) {
            result.resources[resource] = {
                object: getObject(resource),
                quantity: quantity * finalObjectQuantity,
                type: 'raw'
            };
        }
        else {
            const subRecipe = getObjectDefaultRecipe(resource);
            result.resources[resource] = Object.assign({ object: getObject(resource), type: 'not_raw', quantity: quantity * finalObjectQuantity }, getRecipeDependenciesTree(subRecipe, quantity * finalObjectQuantity));
        }
    }
    return result;
};
export { getAllRecipesList, getObjectDefaultRecipe, getObjectRecipes, getRecipeDependenciesTree };
